import React, { ChangeEvent, useState } from "react";
import { Option } from "react-multi-select-component";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import SelectDropdown from "src/Components/GlobalComponents/SelectDropdown";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";
import SimpleInput from "src/Components/SimpleInput";
import {
  buildingNameRegex,
  countryRegex,
  flatVillaNoRegex,
  landmarkRegex,
  streetAddressRegex,
} from "src/lib/constans";

const OrderAddressDetails = ({
  payload,
  setPayload,
  setActiveTab,
  errors,
  validateAddressDetailsForm,
  setErrors,
}: {
  payload: any;
  setPayload: (payload: any) => void;
  setActiveTab: (tab: string) => void;
  errors: {
    [key: string]: string;
  };
  validateAddressDetailsForm: () => boolean;
  setErrors: React.Dispatch<React.SetStateAction<{
    [key: string]: string;
  }>>;
}) => {
  
  const address = [
    { label: "Home", value: "Home" },
    { label: "Work", value: "Work" },
    { label: "Other", value: "Other" },
  ];

  return (
    <div className="w-full max-w-[900px]">
      <div className="flex flex-col w-full gap-2 bg-[#F6FBFF] rounded-lg p-3">
        <h2 className="font-Poppins-SemiBold font-size-18px mb-2 theme-color-green">
          Address Details
        </h2>
        <div className="flex flex-col">
          <CustomWebsiteDropdown
            options={address}
            data={
              payload.address
                ? [{ label: payload.address, value: payload.address }]
                : []
            }
            setData={(data) => {
              setPayload({ ...payload, address: data ? data[0]?.value : "" });
              setErrors((prev) => ({ ...prev, address: "" }));
            }}
            placeholder="Select Address"
            labelText="Address"
            isRequired
            error={errors.address || ""}
          />
          <div className="grid grid-cols-2 gap-2">
            <div className="w-full">
              <SimpleInput
                value={payload.emirate}
                onChange={(value: string) => {
                  setPayload({ ...payload, emirate: value.replace(/[^a-zA-Z\s]/g, "") });
                  setErrors((prev) => ({ ...prev, emirate: "" }));
                }}
                labelText="Province"
                isLabel
                isRequired
                error={errors.emirate}
                maxLength={30}
              />
            </div>
            <div className="w-full">
              <SimpleInput
                value={payload.city}
                onChange={(value: string) => {
                  let filteredValue = value.replace(/[^a-zA-Z\s]/g, "");
                  setPayload({ ...payload, city: filteredValue });
                  setErrors((prev) => ({ ...prev, city: "" }));
                }}
                labelText="City"
                isLabel
                isRequired
                error={errors.city}
                maxLength={30}
              />
            </div>
          </div>
          <div className="w-full">
            <SimpleInput
              value={payload.streetAddress}
              onChange={(value: string) => {
                const filteredValue = value.replace(/[^a-zA-Z0-9\s,+.\/-]/g, "");
                setPayload({ ...payload, streetAddress: filteredValue });
                setErrors((prev) => ({ ...prev, streetAddress: "" }));
              }}
              labelText="Street Address"
              isLabel
              isRequired
              error={errors.streetAddress}
              maxLength={100}
            />
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div className="w-full">
              <SimpleInput
                value={payload.flatVillaNo}
                onChange={(value: string) => {
                  const filteredValue = value.replace(/[^a-zA-Z0-9\s,\/-]/g, "");
                  setPayload({ ...payload, flatVillaNo: filteredValue });
                  setErrors((prev) => ({ ...prev, flatVillaNo: "" }));
                }}
                labelText="House no"
                isLabel
                isRequired
                error={errors.flatVillaNo}
                maxLength={20}
              />
            </div>
            <div className="w-full">
              <SimpleInput
                value={payload.buildingName}
                onChange={(value: string) => {
                  const filteredValue = value.replace(/[^a-zA-Z0-9\s,-]/g, "");
                  setPayload({ ...payload, buildingName: filteredValue });
                  setErrors((prev) => ({ ...prev, buildingName: "" }));
                }}
                labelText="Building Name"
                isLabel
                isRequired
                error={errors.buildingName}
                maxLength={50}
              />
            </div>
          </div>
          <div className="w-full">
            <SimpleInput
              value={payload.additionalInfo}
              onChange={(value: string) => {
                const filteredValue = value.replace(/[^a-zA-Z0-9\s,\/-]/g, "");
                setPayload({ ...payload, additionalInfo: filteredValue });
                setErrors((prev) => ({ ...prev, additionalInfo: "" }));
              }}
              labelText="Additional Information (Area, Landmark)"
              isLabel
              error={errors.additionalInfo}
              maxLength={100}
            />
          </div>
          <div className="w-full">
            <SimpleInput
              value={payload.country}
              onChange={(value: string) => {
                const filteredValue = value.replace(/[^a-zA-Z\s]/g, "");
                setPayload({ ...payload, country: filteredValue });
                setErrors((prev) => ({ ...prev, country: "" }));
              }}
              labelText="Country"
              isLabel
              isRequired
              error={errors.country}
              maxLength={56}
            />
          </div>
        </div>
      </div>
      <div className="w-full mt-3 flex justify-end">
        <PrimaryBtn
          ButtonText="Next"
          onClick={() => {
            if (validateAddressDetailsForm()) {
              setActiveTab("Personal Details");
            }
          }}
          btnExtraStyle={{
            backgroundColor: "#00443F",
            color: "white",
            borderRadius: 50,
          }}
        />
      </div>
    </div>
  );
};

export default OrderAddressDetails;
